import { IBondGelemReport } from 'services/bonds-helper';

export const PREFIX = 'REPORT_DELTA_SHEKEL';

export type IReportDeltaShekelItem = IBondGelemReport & { __isSelected: boolean };
